import { FC } from 'react';

import { NoDashboardDataIcon } from '@/components/ui/Icons/Icons';

import * as S from './Dashboard.styles';

type Props = { title: string; description: string };

export const NoDashboardData: FC<Props> = ({ title, description }) => {
  return (
    <S.NoDataWrapper>
      <NoDashboardDataIcon style={{ marginBottom: '5px' }} />
      <S.TypographyCenter variant="h1">{title}</S.TypographyCenter>
      <S.TypographyCenter variant="body2">{description}</S.TypographyCenter>
    </S.NoDataWrapper>
  );
};
